/*
   Takes in List of Template Suggestions
   and displays them as a list.

   If user clicks on any of the template titles
   It passes back that template id to parent component
   which does stuff with the selected title.

   Use Observable for better piping of the data flow
   for the suggestions for the templates.

   if the length of search string is < 2 then
   return the empty array of templates - donot even make server call
*/
import React, { Component, Fragment } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
   ListGroup,
   ListGroupItem,
   Form,
   FormGroup,
   Label
} from 'reactstrap';

import {
   UpwardAdvancedLoader,
   LoadingInput
} from "ui/index";

// import job service to add get template lists.
import { getTemplateSuggestions } from "../../../../services/suggestions/job";
import { BehaviorSubject, of } from "rxjs";
import {
   debounceTime,
   distinctUntilChanged,
   switchMap,
   map,
} from "rxjs/operators"

const jobSuggestionSearch$ = new BehaviorSubject("");
export const jobSuggestionAutoCompleteObservable$ = jobSuggestionSearch$.pipe(
   debounceTime(300),
   distinctUntilChanged(),
   switchMap((searchString) => {
      if (searchString.length > 2) {
         return getTemplateSuggestions({ "keywords": searchString }).pipe(
            map((data) => { return data })
         )
      } else {
         return of({ templates: [] });
       }
   })
);


class JobTemplateList extends Component {
   constructor(props) {
      super(props);
      this.state = {
         isLoading: false,
         isSearching: false,
         templateSuggestions: [],
         search: "",
         selectedTemplate: null
      }
      this.listSelection = this.listSelection.bind(this);
      this.onSearch = this.onSearch.bind(this);
   }

   componentDidMount() {
      if (this.props.search) {
         this.setState({
            search: this.props.search,
            isLoading: true
         }, () => {
            jobSuggestionSearch$.next(
               this.state.search
            );
         });
      }
      this.templateListSubscription = jobSuggestionAutoCompleteObservable$.subscribe((data) => {
         this.setState({
            templateSuggestions: data.templates,
            isLoading: false,
            isSearching: false
         })
      });
   }

   componentWillUnmount() {
      this.templateListSubscription.unsubscribe();
   }

   onSearch(event) {
      this.setState({
         search: event.target.value,
         isSearching: true
      }, () => {
         jobSuggestionSearch$.next(
            this.state.search
         );
      })
   }

   listSelection(template) {
      this.setState({
         selectedTemplate: template
      }, () => {
         if (this.props.onTemplateSelection) {
            this.props.onTemplateSelection(this.state.selectedTemplate);
         }
      });
   }

   render() {
      const { templateSuggestions, isLoading, selectedTemplate } = this.state;
      const listSelection = this.listSelection;
      return (
         <Fragment>
            <div className="clearfix">
               <Form autoComplete="off">
                  <FormGroup>
                     <Label>Search</Label>
                     <LoadingInput
                        isLoading={this.state.isSearching}
                        type="text"
                        name="jobTemplateSuggestion"
                        value={this.state.search}
                        onChange={this.onSearch}
                     />
                  </FormGroup>
               </Form>
            </div>
            <div style={{ "height": "60vh" }}>
               <PerfectScrollbar>
                  {
                     isLoading ?
                        <UpwardAdvancedLoader size="120" />
                     : (
                        <Fragment>
                           {templateSuggestions.length > 0 ? (
                              <ListGroup>
                                 {
                                    templateSuggestions.map((template, index) => (
                                       <ListGroupItem
                                          key={template.id}
                                          className={'outline-none ' + (selectedTemplate && template.id === selectedTemplate.id ? ' list-group-item-light-green ' : '')}
                                          onClick={() => { listSelection(template) }}
                                          tag="button"
                                          action
                                       >
                                          { template.title }
                                       </ListGroupItem>
                                    ))
                                 }
                              </ListGroup>
                           ) : (
                              <span>"No results..."</span>
                           )
                        }
                        </Fragment>
                     )
                  }
               </PerfectScrollbar>
            </div>
         </Fragment>
      )
   }
}

export default JobTemplateList;
